import { useGenerateAccessKey } from '@api/accessKeys';
import React from 'react';
import { AccessKeyExpiration, AccessKeyType } from 'types/accessKeys';
import { IActionDialogProps } from 'types/common';
import AccessKeyGenerationDialog from '../Helpers/AccessKeyGenerationDialog';

const GenerateDialog: React.FC<IActionDialogProps> = (props) => {
	const accessKeysMutation = useGenerateAccessKey();
	return (
		<AccessKeyGenerationDialog
			{...props}
			showTenantMapping
			translationPrefix={AccessKeyType.access}
			generateKey={accessKeysMutation.mutateAsync}
			defaultExpiration={AccessKeyExpiration.thirty}
		/>
	);
};

export default GenerateDialog;
